import React from "react";
import { Routes, Route } from "react-router-dom";
import OrdersListView from "./components/OrdersListView";

const OrdersPage = () => {
  return (
    <Routes>
      <Route index element={<OrdersListView />} />
    </Routes>
  );
};

export default OrdersPage;
